<template>
  <div id>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card style="min-height:85vh" class="admin_secondary">
            <v-card-title class="secondary white--text">
              General
              <v-spacer></v-spacer>
              <v-btn
                fab
                small
                color="success"
                class="mr-4"
                dark
                @click="save"
                v-if="modified && !loading"
              >
                <v-icon>fa-save</v-icon>
              </v-btn>
              <v-btn icon dark @click="load" :loading="loading">
                <v-icon>fa-sync</v-icon>
              </v-btn>
            </v-card-title>
            <v-container class="white--text">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="website.login_description"
                    dark
                    label="Login Description"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="website.register_description"
                    dark
                    label="Register Description"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="website.newsletter_description"
                    dark
                    label="Newsletter Description"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <v-text-field
                      v-model="website.portals_video.url"
                      dark
                      label="Portals Video"
                      @change="onChange"
                      outlined
                      hide-details
                      class="mr-4"
                    ></v-text-field>

                    <img
                      style="width:75px;height:auto"
                      v-if="website.portals_video.thumbnail"
                      :src="website.portals_video.thumbnail"
                    />
                    <video-uploader class="ml-4" v-model="website.portals_video"></video-uploader>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="website.applicant_success"
                    dark
                    label="Applicant successfully submitted"
                    @change="onChange"
                    outlined
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card class="mt-4">
                    <v-card-title
                      class="secondary white--text clicky"
                      @click="show.portal_limits = !show.portal_limits"
                    >
                      Portal Limits
                      <v-spacer></v-spacer>
                      <v-btn dark icon>
                        <v-icon v-if="show.portal_limits">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show.portal_limits">
                        <v-container>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.total_size"
                                prefix="bytes"
                                label="Max portal size"
                                :suffix="`${website.portal_limits.total_size / 1000 / 1000 / 1000}gb`"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6"></v-col>
                            <v-col cols="6" offset-xs-6>
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.videos"
                                label="Max videos"
                                suffix="/section"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.video_size"
                                prefix="bytes"
                                label="Max video size"
                                :suffix="`${website.portal_limits.video_size / 1000 / 1000 / 1000}gb`"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.photos"
                                label="Max photos"
                                suffix="/section"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.photo_size"
                                prefix="bytes"
                                label="Max photo size"
                                :suffix="`${website.portal_limits.photo_size / 1000 / 1000 }mb`"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.documents"
                                label="Max documents"
                                suffix="/section"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                @change="onChange"
                                v-model="website.portal_limits.document_size"
                                prefix="bytes"
                                label="Max document size"
                                :suffix="`${website.portal_limits.document_size / 1000 / 1000}mb`"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card class="mt-4">
                    <v-card-title
                      class="secondary white--text clicky"
                      @click="show.terms = !show.terms"
                    >
                      Terms
                      <v-spacer></v-spacer>
                      <v-btn dark icon>
                        <v-icon v-if="show.terms">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show.terms">
                        <v-container style="height:530px">
                          <v-row>
                            <v-col cols="12">
                              <vue-editor
                                :editorOptions="editorOps"
                                @text-change="onChangeEditor"
                                v-model="website.terms"
                                style="height:400px"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card class="mt-4">
                    <v-card-title
                      class="secondary white--text clicky"
                      @click="show.privacy = !show.privacy"
                    >
                      Privacy
                      <v-spacer></v-spacer>
                      <v-btn dark icon>
                        <v-icon v-if="show.privacy">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show.privacy">
                        <v-container style="height:530px">
                          <v-row>
                            <v-col cols="12">
                              <vue-editor
                                v-model="website.privacy"
                                @text-change="onChangeEditor"
                                style="height:400px"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-card class="mt-4">
                    <v-card-title
                      class="secondary white--text clicky"
                      @click="show.footer = !show.footer"
                    >
                      Footer
                      <v-spacer></v-spacer>
                      <v-btn dark icon>
                        <v-icon v-if="show.footer">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show.footer">
                        <v-container>
                          <v-textarea
                            :rows="3"
                            v-model="website.footer.description"
                            label="Description"
                            @change="onChange"
                            hide-details
                            outlined
                          ></v-textarea>
                        </v-container>
                        <v-list-item class="secondary lighten-1">
                          <v-list-item-content>
                            <v-text-field
                              dark
                              hide-details
                              clearable
                              outlined
                              label="Social links"
                              v-model="add_footer_link"
                              @keyup.enter="addFooterLink"
                            ></v-text-field>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn fab dark color="primary" small @click="addFooterLink">
                              <v-icon small>fa-plus</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>

                        <v-container>
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <draggable v-model="website.footer.social_links">
                                <v-chip
                                  close
                                  class="ma-2 draggable"
                                  :color="$helpers.linkColor(link)"
                                  dark
                                  v-for="(link,l) in website.footer.social_links"
                                  :key="l"
                                  @click:close="removeLink(link)"
                                >
                                  <v-icon class="mr-4">{{$helpers.linkIcon(link)}}</v-icon>
                                  <a
                                    :href="link"
                                    target="_blank"
                                    class="nolink white--text"
                                  >{{link}}</a>
                                </v-chip>
                              </draggable>
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import videoUploader from "@/components/admin/video-uploader";

export default {
  name: "AdminPortals",
  components: {
    draggable,
    videoUploader
  },
  data() {
    return {
      editorOps: {},
      website: {
        footer: {}
      },
      add_footer_link: "",
      search: "",
      loading: false,
      modified: false,
      show: {
        terms: false,
        privacy: false,
        footer: false,
        portal_limits: false
      }
    };
  },
  async beforeRouteLeave(to, from, next) {
    if (
      this.modified &&
      !confirm("Do you really want to leave? you have unsaved changes!")
    ) {
      return;
    } else {
      next();
    }
  },
  methods: {
    removeLink(link) {
      this.website.footer.social_links.splice(
        this.website.footer.social_links.indexOf(link),
        1
      );
      this.onChange();
    },
    addFooterLink() {
      if (!this.add_footer_link) {
        return;
      }
      this.website.footer.social_links.push(this.add_footer_link);
      this.add_footer_link = null;
      this.onChange();
    },
    onChangeEditor(delta, oldDelta) {
      if (oldDelta.ops[0].insert !== "\n") {
        if (oldDelta.ops.length !== delta.ops.length) {
          this.onChange();
        }
      }
    },
    onChange() {
      this.modified = true;
    },
    async load() {
      this.loading = true;
      try {
        this.website = await this.$api("/admin/website");
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      try {
        this.website = await this.$api.patch("/admin/website", this.website);
        this.modified = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  },
  created() {
    this.load();
  }
};
</script>

<style>
</style>